import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormBaseComponent } from "./../form-base/form-base.component";

@Component({
  selector: "app-form-titulo-privado",
  templateUrl: "./form-titulo-privado.component.html",
  styleUrls: ["../form-base/form-base.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTituloPrivadoComponent extends FormBaseComponent {}
